<template>
	<div class="mini-betslip" :class="{ 'mini-betslip--show': betslipCount > 0 }">
		<div class="mini-betslip__placebet" v-show="showPlaceBet">
			<div class="mini-betslip__stake">
				<button class="mini-betslip__stake__button" @click="setStake(0)">
					Clear
				</button>
				<button
					class="mini-betslip__stake__button"
					@click="setStake(stake + 5)"
				>
					+5
				</button>
				<button
					class="mini-betslip__stake__button"
					@click="setStake(stake + 10)"
				>
					+10
				</button>
				<button
					class="mini-betslip__stake__button"
					@click="setStake(stake + 50)"
				>
					+50
				</button>
				<button
					class="mini-betslip__stake__button"
					@click="setStake(stake + 100)"
				>
					+100
				</button>
				<button
					class="mini-betslip__stake__button"
					@click="setStake(stake + 1000)"
				>
					+1000
				</button>
			</div>
			<div class="mini-betslip__placebet__button__container" v-if="!placingBet">
				<button
					class="mini-betslip__placebet__button"
					@click="placeBet"
					v-if="!areThereAnyInvalidMatches"
				>
					Place Bet ({{ stake | currency }})
				</button>
				<button
					class="mini-betslip__placebet__button"
					@click="removeInvalidMatches"
					v-else
				>
					Remove Locked
				</button>
				<span class="mini-betslip__clear" @click.stop="clear">
					<svg
						width="14px"
						xmlns="http://www.w3.org/2000/svg"
						x="0px"
						y="0px"
						viewBox="0 0 268.476 268.476"
						style="enable-background: new 0 0 268.476 268.476"
						xml:space="preserve"
					>
						<g>
							<path
								style="fill-rule: evenodd; clip-rule: evenodd"
								d="M63.119,250.254c0,0,3.999,18.222,24.583,18.222h93.072   c20.583,0,24.582-18.222,24.582-18.222l18.374-178.66H44.746L63.119,250.254z M170.035,98.442c0-4.943,4.006-8.949,8.949-8.949   c4.943,0,8.95,4.006,8.95,8.949l-8.95,134.238c0,4.943-4.007,8.949-8.949,8.949c-4.942,0-8.949-4.007-8.949-8.949L170.035,98.442z    M125.289,98.442c0-4.943,4.007-8.949,8.949-8.949c4.943,0,8.949,4.006,8.949,8.949v134.238c0,4.943-4.006,8.949-8.949,8.949   c-4.943,0-8.949-4.007-8.949-8.949V98.442z M89.492,89.492c4.943,0,8.949,4.006,8.949,8.949l8.95,134.238   c0,4.943-4.007,8.949-8.95,8.949c-4.942,0-8.949-4.007-8.949-8.949L80.543,98.442C80.543,93.499,84.55,89.492,89.492,89.492z    M218.36,35.811h-39.376V17.899C178.984,4.322,174.593,0,161.086,0L107.39,0C95.001,0,89.492,6.001,89.492,17.899v17.913H50.116   c-7.914,0-14.319,6.007-14.319,13.43c0,7.424,6.405,13.431,14.319,13.431H218.36c7.914,0,14.319-6.007,14.319-13.431   C232.679,41.819,226.274,35.811,218.36,35.811z M161.086,35.811h-53.695l0.001-17.913h53.695V35.811z"
								fill="#D80027"
							/>
						</g>
					</svg>
				</span>
			</div>
			<button class="mini-betslip__placebet__button" v-if="placingBet">
				<loader :margin="false" />
			</button>
		</div>
		<p class="mini-betslip__info" @click.stop="goToBetslip">
			<span class="pull-left">
				<span class="mini-betslip__info__text">Odds</span>
				<span class="mini-betslip__info__num">{{
					totalOdds > 1000000 ? "&#8734;" : Math.round(totalOdds * 100) / 100
				}}</span>
			</span>

			<span class="pull-right">
				<span class="mini-betslip__info__text">Payout</span>
				<span class="mini-betslip__info__num">{{
					(Math.round(possibleWinnings * 100) / 100) | currency
				}}</span>
			</span>
		</p>
	</div>
</template>
<script>
import betslip from "../Betslip/Betslip.vue";
import { isNull } from "lodash";
export default {
	name: "mini-betslip",
	components: { betslip },
	data() {
		return {
			open: false,
			placingBet: false,
			maxPossibleWin: window.MAXIMUM_POSSIBLE_WIN,
		};
	},
	methods: {
		goToBetslip() {
			this.$router.push("betslip");
		},
		placeBet() {
			let vm = this;
			vm.placingBet = true;
			forcePlaceBet()
				.then((response) => {
					vm.placingBet = false;
				})
				.catch((error) => {
					vm.placingBet = false;
				});
		},
		clear() {
			if (window.confirm("Are you sure you want to clear the betslip?"))
				this.$store.commit("clearBetslip");
		},
		setStake(s) {
			this.$store.commit("updateStake", s);
		},
		removeInvalidMatches() {
			this.$store.commit("removeInvalidMatches");
		},
	},
	computed: {
		showPlaceBet() {
			let vm = this;
			return (
				vm.$route.query.hasOwnProperty("watch") &&
				vm.$route.query.watch == "true"
			);
		},
		betslipCount() {
			return this.$store.getters.betSlipCount;
		},
		totalOdds() {
			let oddValues = this.$store.getters.betSlip.map((bet) => {
				return Number(bet.odd.odd_value);
			});

			return oddValues.reduce((a, b) => a * b, 1);
		},
		possibleWinnings() {
			let possibleWin = this.totalOdds * this.stake;
			let maxPossible = this.freebetAppliedStatus ? this.env.maximumFreebetPossibleWin : this.env.maximumPossibleWin;

			return possibleWin > maxPossible
				? maxPossible
				: possibleWin;
		},
		freebetAppliedStatus() {
			let vm = this;
			return vm.$store.getters["freebets/freebetAppliedStatus"];
		},
		stake() {
			let vm = this;
			if (isNull(vm.$store.getters.stake)) {
				vm.$store.commit("updateStake", parseFloat(vm.env.minimumBetAmount));
				return vm.env.minimumBetAmount;
			} else {
				return vm.$store.getters.stake;
			}
		},
		areThereAnyInvalidMatches() {
			return (
				this.$store.getters.betSlip.filter((bet) => {
					return (
						bet.status == "STOPPED" ||
						!Number(bet.odd.odd_value) ||
						(!bet.active && bet.live)
					);
				}).length > 0
			);
		},
	},
};
</script>
<style lang="scss">
.mini-betslip {
	position: fixed;
	width: 100%;
	max-width: var(--app-width);
	min-width: 320px;
	overflow-x: auto;
	bottom: var(--margin-bottom);
	z-index: 9999;
	transition: max-height 500ms ease-in-out;
	visibility: hidden;
	max-height: 0;
	font-size: var(--font-small);
	&--show {
		visibility: visible;
		max-height: 100%;
	}
	&__stake {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		&__button {
			background: var(--black);
			color: var(--white);
			border-radius: 5px;
			padding: 5px;
			border: none;
			box-shadow: 1px 1px 0 0px rgba(0, 0, 0, 1);
			margin-right: 2px;
			margin-bottom: 4px;
			min-width: 25px;
		}
	}
	&__placebet {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0 5px 6px 5px;
		font-size: 0.7rem;
		&__button {
			&__container {
				display: flex;
				flex-direction: row;
				justify-content: space-evenly;
				align-items: center;
			}
			background: var(--black);
			color: var(--white);
			border-radius: 4px;
			padding: 5px 10px;
			border: none;
			box-shadow: 1px 1px 0 0px rgba(0, 0, 0, 1);
			margin-right: 5px;
			margin-bottom: 4px;
		}
	}
	&__clear {
		background: var(--yellow);
		padding: 2px;
		border-radius: 2px;
		box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.3) inset;
	}
	&__info {
		margin: 0;
		text-align: center;
		position: relative;
		background-color: var(--yellow);
		padding: 8px 10px 20px 5px;
		color: var(--always-black);
		&__num {
			text-align: right;
			font-weight: var(--font-weight-medium);
		}
	}
}
</style>
